import { FavoriteAirport } from './user-data/favorite-airport.model';
import { FavoriteEvent } from './user-data/favorite-event.model';

/**
 * Model for user information
 */
export class UserInfo {
  /**
   * User ID
   */
  masterCustomerId: string;

  /**
   * First Name
   */
  firstName: string;

  /**
   * Last Name
   */
  lastName: string;

  /**
   * Home airport identifier
   */
  homeAirportIdent: string;

  /**
   * Favorite airports list
   */
  favoriteAirports: Array<FavoriteAirport>;

  /**
   * List of airport IDs for which this user is an airport manager
   */
  airportsManaged: Array<number>;

  /**
   * List of business IDs for which this user is a business manager
   */
  businessesManaged: Array<number>;

  /**
   * List will contain string flightdeckadmin if user is a flight deck admin
   */
  relevantAceList: Array<string>;

  /**
   * User's default aircraft type
   */
  aircraftType: string;

  /**
   * Favorite airports list
   */
  favoriteEvents: Array<FavoriteEvent>;

  /**
   * Parses user info from the web service
   * @param data User info as returned by the API
   * @returns {UserInfo} Parsed user info
   */
  static parse(data: any): UserInfo {
    return Object.assign(new UserInfo(), {
      masterCustomerId: data.masterCustomerId,
      firstName: data.firstName,
      lastName: data.lastName,
      homeAirportIdent: data.homeAirport,
      aircraftType: data.aircraftType,
      favoriteAirports: (data.favoriteAirports || []).map(d => FavoriteAirport.parse(d)),
      airportsManaged: (data.airportsManaged || []),
      businessesManaged: (data.businessesManaged || []),
      relevantAceList: (data.relevantAceList || []),
      favoriteEvents: (data.favoriteEvents || []).map(d => FavoriteEvent.parse(d))
    });
  }
}
